import { reSendActivationApi } from './resetActivationLinkApi';

export const { useReSendActivationMutation } = reSendActivationApi;

export { reSendActivationApi };
